import React, { useEffect, useState } from "react";
import { Box, Button, Modal } from "@mui/material";
import { Button as Btn, Typography } from "@material-ui/core";
import { ToastContainer } from "react-toastify";
import { Spinner } from "../../components";
import CloseIcon from "@mui/icons-material/Close";
import ApiService from "../../service/ApiService";
import { DatabaseEntities } from "../../model/enum/database-entities.enum";
import AlertService from "../../service/AlertService";
import { DarkGrey } from "../../shared/styles/colors";
import Project from "../../model/project";
import useStyles from "./styles";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "25rem !important",
  bgcolor: "background.paper",
  border: "none",
  borderRadius: "8px",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
  maxHeight: "90vh", // Restrict maximum height to 80% of the viewport height
  overflowY: "auto", // Enable vertical scrolling
  "@media (max-width: 640px)": {
    width: "80%",
  },
};

interface Props {
  project: Project;
  resetList: () => void;
}

// TODO: Implement the apply functionality
// This modal should allow users to apply for a project/job and notify the administration.
// The application should be pending until the administration approves it.
// Implementation waiting for the backend API to be ready.
const ApplyModal = ({ project, resetList }: Props) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  const applyForProject = async () => {
    setLoading(true);
    try {
      await ApiService.post(`${DatabaseEntities.PROJECTS}/apply`, project);
      AlertService.success("Application submitted successfully.");
      resetList();
    } catch (error) {
      AlertService.error("Failed to submit application.");
    } finally {
      setLoading(false);
      resetList();
      handleClose();
    }
  };

  return (
    <div>
      <div className={classes.buttonDiv}>
        <Btn
          className={classes.button2}
          onClick={handleOpen}
          style={{ width: "100%" }}
        >
          Apply now
        </Btn>
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ overflowY: "auto" }}
      >
        {loading ? (
          <Spinner />
        ) : (
          <Box sx={style}>
            <div className={classes.headerDiv}>
              <div className={classes.headerSubDiv2}></div>
              <Btn onClick={handleClose}>
                <CloseIcon />
              </Btn>
            </div>
            <div className={classes.form3}>
              <Typography style={{ fontWeight: 700, fontSize: 24 }}>
                Apply now
              </Typography>
              <Typography
                style={{ fontSize: 16, marginTop: 10, marginBottom: 20 }}
              >
                Are you sure you want to apply for this job?
              </Typography>
              <div className={classes.buttonDiv}>
                <Btn className={classes.button3} disabled>
                  No
                </Btn>
                <Btn className={classes.button2} disabled>
                  Yes
                </Btn>
              </div>
              <Typography
                style={{ fontSize: 12, marginTop: 10, color: DarkGrey }}
              >
                Note: Your request will be pending for approval.
              </Typography>
            </div>
          </Box>
        )}
      </Modal>
      <ToastContainer />
    </div>
  );
};

export default ApplyModal;
